export default __webpack_public_path__ + "static/media/F6.2020d3e9.gif";